<template>
  <div class="foot">
    <div class="box">

      <div class="items">
        <div class="icon-one">
          <img class="icon-xs" src="@/assets/foot/icon-xs.png" alt="">
        </div>
        <div class="page-item">
          <a :href="`${!!i.link ? $Path + i.link : 'javascript:void(0);' }`" v-for="(i, index) in item" :key="index">{{ i.name }}</a>
        </div>
        <div class="icons">
          <span class="us">关注我们</span>
          <span class="wx"><img src="@/assets/foot/icon-wx.png" alt=""> <img class="hover-wx" src="@/assets/foot/hover-wx.png" alt=""></span>
          <span class="dy"><img src="@/assets/foot/icon-dy.png" alt=""> <img class="hover-dy" src="@/assets/foot/hover-dy.png" alt=""></span>
          <span class="xhs"><img src="@/assets/foot/xiaohongshu.png" alt=""><img class="hover-xhs" src="@/assets/foot/hover-xhs.png" alt=""></span>

        </div>

      </div>

      <div class="msg">
        
        <div class="msg-left">
          <div class="calluse">联系我们</div>
          <!-- <div>地址：上海市闵行区申长路988弄虹桥万科中心</div> -->
          <div>地址：福建省莆田市荔园北大道518号</div>
          <!-- <div>邮编：201100</div> -->
          <div>邮编：351131</div>
        </div>

        <div class="msg-right">
          <div>服务热线</div>
          <div>400-8823-777</div>
        </div>
      </div>

      <div class="desc">
        <a class="one" href="https://beian.miit.gov.cn" target="_blank">{{certificate}}</a>
        <div class="two">
          <div>
            <span>相关网站</span>
            <span>
              <a href="https://www.3treesgroup.com/" target="_blank">
                三棵树官网
              </a>
            </span>
            <span>|</span>
            <span>
              <a href="https://www.mashangzhu.com/" target="_blank">
                三棵树马上住
              </a>
            </span>
          </div>
          <div>
            Copyright 2020 SKSHU.com.cn. All Rights Reserved xiaosen.com.cn</div>
          </div>
        <div class="three">
          <a :href="`${$Path}/#/privacy_policy`">隐私政策 </a>
          |
          <a :href="`${$Path}/#/legal_statement`">法律声明</a>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  props: {},
  data () {
    return {
      item: [
        { name: '首页', link: '/#/index' },
        { name: '小森家族', link: '/#/family' },
        { name: '小森案例', link: '/#/case/index' },
        { name: '解决方案', link: '/#/solution' },
        { name: '小森服务', link: '/#/serve' },
        { name: '走进小森', link: '/#/goin' },
        { name: '加入我们', link: '/#/joinus' }
      ],
      certificate: ''
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.selectCertificate()
  },
  methods: {
    selectCertificate() {
      if (location.href.includes('xiaosen.rosun.net')) {
        this.certificate = '沪ICP备10012484号-5'
      } else if (location.href.includes('www.xiaosen.com.cn')) {
        this.certificate = '闽ICP备05007461号-4'
      }
    }
  }
}
</script>

<style scoped lang="less">
.foot{
  position: relative;
  width: 100%;
  height: 560px;
  background: #043E29;
  display: flex;
  justify-content: center;
  .box{
    width: 1920px;
    padding: 142px 91px 53px 91px;
    .items{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .icon-one {
        width: 400px;
        height: 47px;
        text-align: left;
        .icon-xs{
          width: 260px;
          vertical-align: top;
        }
      }
      .page-item{
        width: 576px;
        display: flex;
        flex-wrap: wrap;
        a{
          text-decoration: none;
          width: 102px;
          margin-right: 56px;
          text-align: left;
          font-size: 24px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 53px;
          opacity: 0.8;
          &:nth-of-type(4) {
            margin-right: 0!important;
          }
        }
      }
      .icons{
        width: 400px;
        display: flex;
        align-items: center;
        .us{
          display: block;
          width: 125px;
          font-size: 30px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 53px;
          margin-right: 35px;
        }
        img{
          width: 100%;
          height: 100%;
        }
        .wx{
          width: 54px;
          height: 46px;
          margin-right: 40px;
          position: relative;
          display: flex;
          .hover-wx{
            position: absolute;
            width: 214px;
            height: 326px;
            top: -330px;
            right: -75px;
            display: none;
            z-index: 9;
          }
        }
        .dy{
          position: relative;
          width: 34px;
          height: 43px;
          margin-right: 40px;
          display: flex;
          .hover-dy{
            position: absolute;
            width: 214px;
            height: 326px;
            top: -330px;
            right: -93px;
            display: none;
            z-index: 9;
          }
        }
        .wx:hover .hover-wx{
          display: block;
        }
        .dy:hover .hover-dy{
          display: block;
        }
        .xhs {
          width: 81px;
          height: 28px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            vertical-align: top;;
          }
          .hover-xhs{
            position: absolute;
            width: 214px;
            height: 326px;
            top: -330px;
            right: -63px;
            display: none;
            z-index: 9;
          }
          &:hover .hover-xhs{
            display: block;
          }
        }
      }
    }

    .msg{
      margin-top: 81px;
      display: flex;
      justify-content: space-between;
      color: #fff;
      text-align: left;
      .msg-left{
        font-size: 24px;
        line-height: 36px;
        .calluse {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 5px;
        }
      }
      .msg-right{
        font-size: 40px;
        line-height: 50px;
        letter-spacing: 2px;
        & div:nth-of-type(1) {
          font-size: 32px;
          font-weight: 700;
        }
      }
    }

    .desc{
      margin-top: 10px;
      font-size: 20px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .one {
        text-decoration: none;
        opacity: 0.5;
        color: #FFFFFF;
      }
      .two{
        div:nth-of-type(1) {
          margin-bottom: 10px;
          span:nth-of-type(1) {
            opacity: 0.8;
            color: #fff;
            margin-right: 15px;
          }
          span:not(:nth-of-type(1)) {
            opacity: 0.5;
            a {
              text-decoration: none;
              color: #fff;
            }
          }
          span:nth-of-type(3) {
            margin: 0 10px;
          }
        }
        div:nth-of-type(2) {
          opacity: 0.5;
        }
      }
      .three {
        opacity: 0.5;
        a {
          text-decoration: none;
          color: #fff;
        }
      }
    }
  }
}
</style>
